
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jugadores/puntos-la-liga-fantasy/[...slug]",
      function () {
        return require("private-next-pages/jugadores/puntos-la-liga-fantasy/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jugadores/puntos-la-liga-fantasy/[...slug]"])
      });
    }
  